import React from 'react';
import { Menu, Text,  Image, Icon, HStack } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router';
import { LuChevronUp, LuChevronDown } from "react-icons/lu"
import { NavLink } from './Sidenav';


const NavItem = ({ 
    item, 
}: {
    item: NavLink,
}) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const isActive = pathname.includes(item.path as string);
    const hasSubselections = item.subselections && item.subselections.length > 0;

    const handleClick = (e: React.MouseEvent) => {
        if (hasSubselections) {
            e.preventDefault();
            setIsOpen(!isOpen);
        } else {
          navigate(item.path as string);
        }
    };

    return (
        <>
            <Menu.Item
              value={item.path || item.title} 
              p={4}
              px={5}
              borderRadius={0}
              cursor="pointer"
              bg={isActive ? 'brand.focusRing' : 'inherit'}
              color={isActive ? 'brand.contrast' : 'primary'}
              _hover={isActive ? {} : { bg: 'bg.muted' }}
              onClick={handleClick}

            >

                <HStack gap={4} flex='1' alignItems={'center'} justifyContent="center" pos={'relative'}>
                  {item.iconEl
                    ? item.iconEl
                    : <Image src={isActive ? item.iconContrast : item.icon} width={5} />
                  }
                  <Text fontSize='md' flex='1' display={{base: 'none', xl: 'inherit'}}>{item.title}</Text>
                  {hasSubselections && (
                    <Icon size='md' display={{base: 'none', xl: 'inherit'}}>
                      {isOpen ? <LuChevronUp /> : <LuChevronDown />}
                    </Icon>
                  )}
                </HStack>
            </Menu.Item>
            {isOpen && item.subselections && item.subselections.map((sub, idx) => (
                <NavItem item={sub} key={idx}/>
            ))}
        </>
    )
}

export default NavItem;
